package org.hs_soft.runmynesto.domain.model.home.dashboard.dashboard_config


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class CashRegister(
    @SerialName("id")
    val id: String?,
    @SerialName("isAvailableInWebApp")
    val isAvailableInWebApp: Boolean?,
    @SerialName("name")
    val name: String?,
    @SerialName("shopId")
    val shopId: String?,
    @SerialName("__typename")
    val typename: String?
)